module.exports = "/assets/data/e14e363e3aa4f20d9ea2a37ddbe9d303-GU21.data.json";